import { apiAxios } from '/@/modules/core/app/helpers/AxiosHelper';
import { NavItem } from '/@/modules/core/nav/models/NavItem';
import { Route } from '/@/modules/core/app/constants/api.constants';

class NavResource {
  /**
   * @returns {Promise<Array>}
   */
  async getNav(params = {}) {
    const items = await apiAxios.get(Route.UI_NAV, { params });
    return NavItem.mapModels(items);
  }
}

export default new NavResource();
